import React, {Component} from 'react';
import IconMenu from 'material-ui/IconMenu';
import MenuItem from 'material-ui/MenuItem';
import FlatButton from 'material-ui/FlatButton';

import { intlShape } from 'react-intl';

const localeMessages = {
  logout: {
    id: 'Supporter.Account.Logout',
    defaultMessage: 'Abmelden'
  },
};

class AccountMenu extends Component {
  static contextTypes = {
    intl: intlShape.isRequired,
  }

  render() {
    return (
      <IconMenu
        iconButtonElement={
          <FlatButton style={{color:'white'}}label={this.props.user.name} />
        }
        targetOrigin={{horizontal: 'right', vertical: 'top'}}
        anchorOrigin={{horizontal: 'right', vertical: 'top'}}
      >
        <MenuItem onClick={this.props.onLogout} primaryText={this.context.intl.formatMessage(localeMessages.logout)} />
      </IconMenu>
    );
  }
};

export default AccountMenu;


// WEBPACK FOOTER //
// ./src/AccountMenu.js